import { reducers } from 'redux/core'
import request from 'sb-request'


const fetch = () =>
  request.get('rest/user/reviews')
    .then(({ items }) => reducers.models.reviews.set(items))


export default {
  fetch,
}
